import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Text } from '@daedalus/atlas/Text';
import { Toggle } from '@daedalus/atlas/Toggle';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { DesktopIcon } from '../PriceWatchInfoIcon/DesktopIcon';
import { MobileIcon } from '../PriceWatchInfoIcon/MobileIcon';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wlheiep",
  propsAsIs: false
});
export const ToggleWrapper = /*#__PURE__*/styled('div')({
  name: "ToggleWrapper",
  class: "t1vxzpbl",
  propsAsIs: false
});
export const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t1bi8lnb",
  propsAsIs: false
});
export const PulseAnimation = /*#__PURE__*/styled('div')({
  name: "PulseAnimation",
  class: "p1eyat1i",
  propsAsIs: false
});
type PriceWatchToggleProps = {
  isToggleOn: boolean;
  handleClick: (event: React.SyntheticEvent<Element, Event>) => void;
  shouldPulse?: boolean;
};
export const PriceWatchToggle = ({
  isToggleOn,
  handleClick,
  shouldPulse = true
}: PriceWatchToggleProps) => {
  const {
    isMobile
  } = useDeviceLayout();
  return <>
      <Wrapper>
        <PulseAnimation className={cx(shouldPulse && 'shouldPulse')}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.75" cx="12" cy="12" r="12" />
            <circle cx="12" cy="12" r="12" />
            <path d="M11.9999 5.6001C9.34889 5.6001 7.19985 7.74913 7.19985 10.4001V11.866L5.65696 15.1446C5.5695 15.3305 5.58319 15.5482 5.69325 15.7216C5.80332 15.895 5.99445 16.0001 6.19985 16.0001H9.01301C9.02024 16.0646 9.0315 16.1425 9.04906 16.2303C9.09607 16.4654 9.19093 16.7847 9.38541 17.1088C9.79764 17.7958 10.5966 18.4001 11.9999 18.4001C13.4032 18.4001 14.2022 17.7958 14.6144 17.1088C14.8089 16.7847 14.9037 16.4654 14.9508 16.2303C14.9683 16.1425 14.9796 16.0646 14.9868 16.0001H17.7999C18.0053 16.0001 18.1964 15.895 18.3065 15.7216C18.4165 15.5482 18.4302 15.3305 18.3427 15.1446L16.7999 11.866V10.4001C16.7999 7.74913 14.6508 5.6001 11.9999 5.6001ZM10.2268 16.0001H13.773C13.7447 16.1393 13.6896 16.3177 13.5854 16.4914C13.3976 16.8043 12.9966 17.2001 11.9999 17.2001C11.0032 17.2001 10.6022 16.8043 10.4144 16.4914C10.3102 16.3177 10.2551 16.1393 10.2268 16.0001ZM8.39985 10.4001C8.39985 8.41187 10.0116 6.8001 11.9999 6.8001C13.9881 6.8001 15.5999 8.41187 15.5999 10.4001V12.0001C15.5999 12.0884 15.6194 12.1757 15.657 12.2556L16.8544 14.8001H7.14532L8.34275 12.2556C8.38035 12.1757 8.39985 12.0884 8.39985 12.0001V10.4001Z" fill="white" />
          </svg>
        </PulseAnimation>

        <TextWrapper>
          <Text variant="bodyS">
            <FormattedMessageWrapper id="priceWatchDetailedToggle.alertMessage" defaultMessage="Alert me when the price changes" />
          </Text>
          {isMobile ? <MobileIcon /> : <DesktopIcon />}
        </TextWrapper>

        <ToggleWrapper>
          <Toggle checked={isToggleOn} id="PriceWatchToggle" onChange={handleClick} />
        </ToggleWrapper>
      </Wrapper>
    </>;
};

require("./PriceWatchToggle.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceWatchToggle.tsx");